export const buildAbsoluteUrl = (path: string): string => `${window.location.origin}/${path.replace(/^\/+/, '')}`;
